export { default } from "./BaseMenu.vue";
